<template>
  <div class="foreword">
    <h1>Foreword</h1>
    <p>
      As part of the BC Centre for Excellence (BC-CfE) in HIV/AIDS's mandate to
      evaluate the outcomes of STOP HIV/AIDS programming in BC, we have developed
      quarterly HIV/AIDS monitoring reports. These reports provide up-to-date data on
      a variety of key HIV-related surveillance and treatment indicators. Selection of
      these indicators was achieved through a collaborative process with various Health
      Authority (HA) representatives. There are six reports in total, one for each HA
      and one for the province of BC as a whole. In addition, there is a technical report
      which explains how each HIV indicator is calculated. Data used in these reports
      come from the British Columbia Centre for Disease Control (BCCDC), MSP billings,
      hospitalization data from the Discharge Abstract Database, the Sunquest
      Laboratory database at the Provincial Public Health Microbiology and Reference
      Laboratory, Providence Health Care laboratory, BC Vital Statistics, and the BC-CfE
      Drug Treatment Program (DTP) Database.
      The STOP HIV/AIDS program is funded by the Province of British Columbia's Ministry of Health. 
    </p>
    <p>
      The objectives of the quarterly HIV/AIDS monitoring reports are to:
    </p>
    <ol>
      <li>
        Provide timely HA-specific information on key HIV indicators which will
        guide and inform HIV leaders and innovators in the development of future
        HIV interventions and programs which will ultimately lead to decreasing
        the burden of HIV in BC. The indicators will reflect ongoing or past successful
        public health interventions and highlight areas in the HIV care spectrum
        which require further attention and support.
      </li>
      <li>
        Highlight limitations in our current data due to incomplete or time lagged
        data and to develop future strategies to improve complete and timely data
        capture.
      </li>
    </ol>
    <p>
      These reports are produced for the benefit of individual HA’s. As such, we are
      enthusiastic about your involvement and cooperation regarding the development
      of these monitoring reports. Please forward your comments and queries to
      Dr. Rolando Barrios, Senior Medical Director
      at the BC-CFE, at <a href="mailto:rbarrios@cfenet.ubc.ca">rbarrios@cfenet.ubc.ca</a>.
    </p>

    <p v-if="$route.params.ha == 'xxx'" style="background-color: rgba(255, 255, 0, 0.5);"><i>
      * Be advised that a transposition of the column headers for indicator 4.4
      'Stage of HIV Infection at Time of Diagnosis by Exposure Category' occurred in
      some previous QMRs. Specifically, the PWID and Heterosexual column headers were switched in Figure 4.4.
      This transposition affects reports for Q3 2017 through Q2 2018.
       If you have any questions, please contact Irene Day
      at <a href="mailto:iday@cfenet.ubc.ca">iday@cfenet.ubc.ca</a>.
    </i></p>


  </div>
</template>

<script>
export default {
  name: 'foreword',
  data () {
    return {
      msg: 'Home'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// Foreword.vue?30a4ae39